module.exports = __webpack_public_path__ + "static/media/A4-portrait-v3.7c89a6eb.svg";